import { QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorFallback } from './components/error-fallback';
import { NotFound } from './components/not-found';
import { installGlobalErrorHandlers } from './lib/error-reporter';
import { createQueryClient } from './lib/query-client';
import { installStaleBuildHandler } from './lib/stale-build';
import { initTheme } from './lib/theme';
import { routeTree } from './routeTree.gen';
import './styles.css';

installGlobalErrorHandlers();
installStaleBuildHandler();
initTheme();

const queryClient = createQueryClient();

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  // Loaders read through the query cache, so the router need not cache too.
  defaultPreloadStaleTime: 0,
  defaultErrorComponent: ErrorFallback,
  defaultNotFoundComponent: NotFound,
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
